export class LoadingController {
  private readonly panel = document.getElementById('loadingPanel');
  private readonly message = document.getElementById('loadingMessage');
  private readonly progress = document.getElementById('loadingProgress');
  private readonly toast = document.getElementById('errorToast');
  private toastTimer: number | undefined;

  update(message: string, progress: number): void {
    if (this.message) this.message.textContent = message;
    if (this.progress) {
      this.progress.style.width = `${Math.max(0, Math.min(progress, 100))}%`;
    }
  }

  complete(): void {
    this.update('徳島市の3D空間を準備しています', 100);
    window.setTimeout(() => this.panel?.classList.add('is-complete'), 450);
  }

  showError(message: string): void {
    if (!this.toast) return;
    this.toast.textContent = message;
    this.toast.hidden = false;
    this.toast.classList.add('is-visible');
    if (this.toastTimer !== undefined) window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => {
      this.toast?.classList.remove('is-visible');
      window.setTimeout(() => {
        const toast = this.toast;
        if (toast && !toast.classList.contains('is-visible')) toast.hidden = true;
      }, 250);
    }, 6500);
  }
}
